import { Form } from 'antd';
import CodeEditor from '@uiw/react-textarea-code-editor';
import React, { CSSProperties } from 'react';

interface JavascriptCodeInputProps {
    isDetailMode: boolean | undefined;
    fieldName: string | number | (string | number)[];
    isFeatureDisabled: boolean;
    fieldKey?: string | number | (string | number)[];
    enableControls: boolean;
    // eslint-disable-next-line react/no-unused-prop-types
    jsCode: string | undefined;
    label?: string;
    functionSignature?: string;
}

interface TransformFunctionInputProps {
    id?: string;
    value?: string;
    onChange?: (value: string) => void;
    disabled: boolean;
    functionSignature?: string;
}

const transformFunctionTop = (
    signature = 'function yourFunction(payload, queryParams, clientConfigs, DI, path)',
): string => `${signature} {`;
const transformFunctionBottom = '}';

const TransformFunctionInput: React.FC<TransformFunctionInputProps> = ({
    value,
    onChange,
    disabled,
    functionSignature,
    id,
}: TransformFunctionInputProps) => {
    const baseStyle: CSSProperties = {
        cursor: 'not-allowed',
        overflowY: 'scroll',
        resize: 'none',
        fontSize: 12,
        backgroundColor: '#f1f1f1',
        fontFamily: 'ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace',
    };
    const inputStyle = {
        backgroundColor: '#f9f9f9',
        cursor: disabled ? 'default' : 'text',
        ...(disabled ? { maxHeight: '90vh' } : {}),
        minHeight: '60px',
    };
    return (
        <>
            <CodeEditor
                value={transformFunctionTop(functionSignature)}
                language="js"
                padding={0}
                style={baseStyle}
                disabled
            />
            <div style={{ paddingLeft: '25px', backgroundColor: inputStyle.backgroundColor }}>
                <CodeEditor
                    id={id}
                    language="js"
                    placeholder="Please enter JS code."
                    padding={0}
                    style={{ ...baseStyle, ...inputStyle }}
                    value={value}
                    onChange={(e): void => onChange?.(e.target.value)}
                    disabled={disabled}
                />
            </div>
            <CodeEditor value={transformFunctionBottom} language="js" padding={0} style={baseStyle} disabled />
        </>
    );
};

const JavascriptCodeInput: React.FC<JavascriptCodeInputProps> = ({
    isFeatureDisabled,
    isDetailMode,
    fieldName,
    fieldKey,
    enableControls,
    label = 'Code',
    functionSignature,
}) => {
    return (
        <Form.Item
            label={label}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            name={fieldName}
            fieldKey={fieldKey}
            rules={[
                {
                    required: !isFeatureDisabled,
                    message: 'Field Code is required',
                },
            ]}
        >
            <TransformFunctionInput
                id={Array.isArray(fieldName) ? fieldName.join('_') : `${fieldName}`}
                disabled={isDetailMode || isFeatureDisabled || !enableControls}
                functionSignature={functionSignature}
            />
        </Form.Item>
    );
};

export default JavascriptCodeInput;
